import React from 'react'
import PropTypes from 'prop-types'

import {withModule} from '../redux/goose'

import {connect} from 'react-redux'
import {bindActionCreators,compose} from 'redux'

import DevAuthModule from '../redux/modules/auth/dev'


class DevAuthContainer extends React.PureComponent{
  render(){
    return ( null )
  }
}

export default compose(
  withModule(DevAuthModule)
)(DevAuthContainer)



// WEBPACK FOOTER //
// ./src/Containers/DevAuthContainer.js